import React from 'react';
import Order from '../../views/orderAction';
import iconGold from '../../img/card_gold.jpg';
import '../../less/order';
import {Control} from 'MWC';

export default function template() {
    return (
        <div className="module-cards-order">
            <div className="content">
                <div className="landing">
                    <Control>
                        <h1>{this.l10n('CARDS_ORDER_NAME_GOLD')}</h1>
                    </Control>
                    <Control>
                        <b>{this.l10n('CARDS_FEATURE_LIMIT_LABEL')}</b>
                        &nbsp;
                        <b>{this.l10n('CARDS_FEATURE_LIMIT_TO')}</b>
                        <b>&nbsp;{this.l10n('CARDS_FEATURE_LIMIT_GOLD')}&nbsp;</b>
                        <b>{this.l10n('CARDS_FEATURE_LIMIT_CURRENCY')}</b>
                    </Control>
                    <div className="feature__list">
                        <ul>
                            <li>
                                {this.l10n('CARDS_FEATURE_COST_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_COST_GOLD')}
                            </li>
                            <li>
                                {this.l10n('CARDS_FEATURE_PERIOD_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_PERIOD_TO')}
                                &nbsp;
                                {this.l10n('CARDS_FEATURE_PERIOD_GOLD')}
                                &nbsp;
                                {this.l10n('CARDS_FEATURE_PERIOD_TERM')}
                            </li>
                            <li>
                                {this.l10n('CARDS_FEATURE_MANAGER_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_MANAGER_GOLD')}
                            </li>
                            <li>{this.l10n('CARDS_FEATURE_APP_LABEL')}</li>
                        </ul>
                    </div>
                    <Control>
                        <div className="order-step__list">
                            <div className="order-step__item one">
                                {this.l10n('CARDS_ORDER_STEP_ONE')}
                            </div>
                            <div className="order-step__arrow" />
                            <div className="order-step__item two">
                                {this.l10n('CARDS_ORDER_STEP_TWO')}
                            </div>
                            <div className="order-step__arrow" />
                            <div className="order-step__item three">
                                {this.l10n('CARDS_ORDER_STEP_THREE')}
                            </div>
                        </div>
                    </Control>
                </div>
                <div className="order">
                    <Control>
                        <h3>{this.l10n('CARDS_ORDER_TYPE_GOLD')}</h3>
                    </Control>
                    <Control>
                        <Order {...this.props} type="gold" />
                    </Control>
                    <div>
                        <img src={iconGold} width={320} />
                    </div>
                </div>
            </div>
        </div>
    );
}
